var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountchat = function SvgAccountchat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21 11.291c0 4.539-4.048 8.182-9 8.182a9.896 9.896 0 0 1-1.87-.179M6.599 17.826C4.42 16.336 3 13.974 3 11.291M6.599 17.826v3.215"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3 11.291C3 6.752 7.048 3.11 12 3.11s9 3.643 9 8.182M10.13 19.29 6.6 21.04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.177 11.323a.25.25 0 1 1-.354.354.25.25 0 0 1 .354-.354M16.177 11.323a.25.25 0 1 1-.354.354.25.25 0 0 1 .354-.354M8.177 11.323a.25.25 0 1 1-.354.354.25.25 0 0 1 .354-.354"
  })));
};
export { SvgAccountchat as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNmZmNTRhNTBjYWRiYzk1NmYzM2YyNmQzMTNhODIzZGQuc3ZnIjs=";